<template>
	<div>
		<el-row :gutter="40">
			<el-col :span="16">
				<data-tables :data="itemBase.filter(data => !search || data.displayName.toLowerCase().includes(search.toLowerCase()))" style="width: 100%; overflow:auto;" border ref="itemBase" @filter-change="filterChange" @sort-change="sortChange" :filters="currentFilters" @current-page-change="currentPageChange" :current-page="page" :page-size="pageSize" @size-change="sizeChange">
				    <el-table-column label="Предмет" prop="displayName" sortable sort-by="displayName" :filters="filters" :filter-multiple="true">
				      <template slot-scope="scope">
				      	<el-image style="width: 32px; height: 32px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="scope.row.image"></el-image>
				        <span>{{scope.row.displayName}}</span>
				      </template>
				    </el-table-column>
				    <el-table-column label="Опции" width="320" prop="options" align="right">
				    	<template slot="header" slot-scope="scope">
					        <el-input style="width: 100%; padding: 0;" v-model="search" size="mini" placeholder="Предмет"/>
					    </template>
				      	<template slot-scope="scope">
				      		<!-- <el-button v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" size="mini" @click="removeItem({item: scope.row.value, doc: scope.row.doc, mod: scope.row.mod})">Удалить из базы данных</el-button> -->
				      		<el-button v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" size="mini" @click="changeIcon.visibility=true;changeIcon.item=scope.row.name;changeIcon.mod=scope.row.mod;">Заменить иконку</el-button>
							<el-button v-if="scope.row.params != false" size="mini" @click="editItem(scope.row.params)">Редактировать</el-button>
							<el-button v-if="scope.row.params == false" size="mini" @click="addItem({item: scope.row.name, mod: scope.row.mod, index: scope.$index});">Добавить</el-button>
				      	</template>
				    </el-table-column>
				</data-tables>
				<el-dialog title="Замена иконки" :visible.sync="changeIcon.visibility" width="400px">
				  	<el-input v-model="changeIcon.image" clearable type="text" placeholder="Новый data64"></el-input>
				  	<span slot="footer" class="dialog-footer">
				    	<el-button size="mini" @click="changeIcon.visibility=false">Отмена</el-button>
				    	<el-button size="mini" @click="changeIconConfirm">Заменить</el-button>
				  	</span>
				</el-dialog>
			</el-col>
		</el-row>
		<hr>	
		<el-row :gutter="40">
			<el-col>
				<p>На этой странице выводится база предметов. Эта страница аналогична странице "Коллекция предметов", за исключение столбца со стоимостями предметов. Так же отличием является наличие всех предметов, заложенных в базу данных. С этой страницы удобно в экспресс формате добавлять предметы в коллекцию, с последующим редактированием. Для добавления предметов нажмите на кнопку "Добавить", находящуюся в правом углу ряда с предметом. Если предмет уже находится в коллекции, то вместо кнопки "Добавить" будет находится кнопка "Редактировать". На эту страницу можно вернуться нажатием на кнопку "Назад" со страницы редактирования предмета.</p>
			</el-col>
		</el-row>	
	</div>
</template>

<script>
import {db} from '../firebase.js';
import {addItem, setFilterAndSort, filterChange, sortChange, currentPageChange, sizeChange} from '../functions.js';
export default {
  	data() {
	    return {
	    	changeIcon: {
	    		visibility: false,
	    		image: '',
	    		item: '',
	    		mod: '',
	    	},
	    	search: '',
	    	itemBase: [],
    		filters: [],
    		uid: (this.$store.state.user) ? this.$store.state.user.uid : null,
    		tableName: 'itemBase',
    		currentFilters: [],
    		page: 1,
    		pageSize: 20,
    		recomputedIBase: 0,
	    };
  	},
  	watch: {
  		recomputedIBase(){
  			var self = this;
			var itemBase = [];
			for (var prop in self.$store.state.itemCollection) {
				self.$store.state.itemCollection[prop].forEach(el=>{
					el.params = false;
					var mod = self.$store.state.userCollection[prop];
					var item = undefined;
					if (mod) {
						item = mod.find(subEl=>{
							return subEl.item == el.name;
						});
					};
					if (item) {
						el.params = {
		  					name: 'edit item',
		  					params: {
		  						item: el.name,
		  					},
		  				};
					};
					itemBase.push(el);
				});
			};
			self.itemBase = itemBase;
  		},
  	},
  	computed: {
  	},
  	mounted() {
  		var self = this;
		self.setFilterAndSort();
		self.recomputedIBase++;
  		if (self.itemBase.length == 0) {
  			self.$store.subscribe((mutation, state) => {
		      	switch(mutation.type) {
		        	case 'updateUserCollection':
  						self.recomputedIBase++;
		        		self.uid = self.$store.state.user.uid;
		        	break;
		      	};
		    });
		};
  		self.filters = self.$store.state.filters;
		self.$store.subscribe((mutation, state) => {
	      	switch(mutation.type) {
	        	case 'updateFilters':
	        		self.filters = self.$store.state.filters;
	        	break;
	      	};
	    });
  	},	
	methods: {
		changeIconConfirm(){
			var self = this;
			var item = self.$store.state.itemCollection[self.changeIcon.mod].find(el=>{return el.name == self.changeIcon.item});
			var data = {};
			data[self.changeIcon.item] = {
				itemName: item.itemName,
	        	itemID: item.itemID,
	        	itemMeta: item.itemMeta,
	        	displayNameRu: item.displayNameRu,
	        	recipe: item.recipe,
				image: self.changeIcon.image,
			};
			db.collection('mods').doc(self.changeIcon.mod).update(data).then(function(){
				self.$notify({title: 'Успех', message: 'Иконка успешно обновлена', type: 'success'});
			});
		},
		setFilterAndSort: setFilterAndSort,
		filterChange: filterChange,
		sortChange: sortChange,
		currentPageChange: currentPageChange,
		sizeChange: sizeChange,
		removeItem(props) {
			/*if (props.doc != undefined) {
				var consent = confirm('Вы уверены что хотите удалить этот предмет из базы данных?');
				if (consent) {
					props.doc.ref.delete();
					db.collection('mods').doc(props.mod).get().then(function(doc){
						var items = doc.data().items;
						var itemProp = props.item.split(':');
						var itemName = itemProp[0] + ':' + itemProp[1];
						var itemMeta = itemProp[2]*1;
						items.forEach(function(el, i){
							if (el.itemName == itemName && el.itemMeta == itemMeta) {
								items.splice(i, 1);
								return false;
							};
						});
						db.collection('mods').doc(self.form.mod).set({items: items});
					});
				};
			};*/	
		},	
  		addItem: addItem,
  		editItem(params) {
  			var self = this;
  			self.$router.push(params);
  		},
    },  	
};
</script>
